// AdminPanel.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Inventory from "./Inventory";
import OrderHistory from "./OrderHistory";
import Shipping from "./Shipping";
import Stats from "./Stats";
import UploadStock from "./UploadStock";
import AboutUsPanel from "./AboutUsPanel"; 
import ImageUploadPanel from "./ImageUploadPanel";

const Dashboard = () => (
  <div className="p-6">
    <h1 className="text-4xl font-bold">Bienvenido al Panel de Administración</h1>
    <p className="text-gray-600 mt-2">Selecciona una opción en el menú lateral para administrar tu tienda.</p>
  </div>
);

const AdminPanel = () => {
  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="flex-1 ml-64 p-6">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/inventory" element={<Inventory />} />
          <Route path="/orders" element={<OrderHistory />} />
          <Route path="/shipping" element={<Shipping />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/upload-stock" element={<UploadStock />} />
          <Route path="/about-update" element={<AboutUsPanel />} />
          <Route path="/image-upload" element={<ImageUploadPanel />} />
        </Routes>
      </div>
    </div>
  );
};

export default AdminPanel;
